import type { VendorAccountStatus, VendorUserResponseDTO, VendorUserRoleDTO } from './dto-client'

export interface VendorUser {
    id: number
    email: string
    firstName: string
    lastName: string
    role?: VendorUserRoleDTO
    hasAccessToVerificationApp: boolean
    status: VendorAccountStatus
    version: number
}

/**
 * Maps the VendorUserResponseDTO wire shape to the normalized VendorUser.
 * Replaces the former VendorUser model class. The class's `getFullName(market)`
 * method is now the `vendorUserFullName` formatter in @leanpay/utils.
 */
export const toVendorUser = (data: VendorUserResponseDTO): VendorUser => ({
    id: data.id,
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    role: data.role,
    hasAccessToVerificationApp: data.hasAccessToVerificationApp,
    status: data.status,
    version: data.version,
})
